import {apply, applyBackground, applyStyle} from './index';
import stylefunction from './stylefunction';

export default {
  apply: apply,
  applyBackground: applyBackground,
  applyStyle: applyStyle,
  stylefunction: stylefunction
};
